import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from '@core-app/services/auth.service';
import { FeatureFlagsService } from '@core-app/services/feature-flags.service';
import { APP_CONFIG } from '@frontend-workspace/app-config';

@Component({
  selector: 'frontend-workspace-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AuthComponent {
  private readonly _appConfig = inject(APP_CONFIG);
  private readonly _authService = inject(AuthService);

  readonly featureFlags = inject(FeatureFlagsService);

  loginDisplay = false;
  appVersion: string = this._appConfig.displayVersionNumber;

  constructor() {
    this._authService.saveAuthenticatedUser();
  }

  login() {
    this._authService.login();
  }
}
